export default "__VITE_ASSET__CHw5$0aj__"